export default "__VITE_ASSET__D0JQGR6W__"